<template>
  <nav class="navbar navbarWeb">
    <span @click="toggleLanguage" class="global-icon" style="cursor: pointer">
      {{ $t("language") }}
      <i class="fas fa-globe"></i>
    </span>
    <div class="navbar-toggle" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <ul class="navbar-items" :class="{ 'show-menu': isMenuOpen }">
      <li></li>
      <li class="has-submenu">
        <a href="/categories"  :class="{ leftNav: langVar === 'ar' }">{{ $t("categories") }} </a>
      </li>
      <li>
        <a href="/home" :class="{ leftNavEn: langVar === 'en' }">{{
          $t("home")
        }}</a>
      </li>
    </ul>
    <a href="/home" class="logoNav">
      <img src="../../assets/images/logo.png" alt="AlFursan Logo" />
    </a>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store";

export default {
  data() {
    return {
      isMenuOpen: false,
      langVar: store.state.currentLang,
    };
  },
  
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleLanguage() {
      if (store) {
        store.commit("toggleLanguage"); // Toggle the language in the store
        this.$router.go();
      } else {
        // console.error("Vuex store is not available.");
      }
    },
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      if (store) {
        return store.state.currentLang;
      }
      return "";
    },
  },
};
</script>

<style>
.homeNav {
  display: none;
}

.navbar{
  justify-content: space-between !important;
}

.navbarWeb {
  background-color: #2B2B2B !important;
  box-shadow: 0 5px 5px rgba(78, 73, 73, 0.2);
  padding: 10px;
  direction: ltr;
  justify-content: center;
  z-index: 10;
}

.leftNav {
  margin-right: 750%;
}

.leftNavEn {
  margin-right: 980%;
}

.navbar-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  direction: ltr;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 22%;
}

.navbar-items li {
  margin-right: 40px;
}

.navbar-items li:last-child {
  margin-right: 0;
}

.navbar-items a {
  text-decoration: none;
  color: white;
  padding: 8px;
}

.global-icon {
  color: white;
  font-size: 15px;
  padding-left: 5%;
}

.navbar-items a:hover,
.global-icon:hover {
  color: #f9c752;
}

.has-submenu:hover .submenu {
  display: block;
  padding: 2px;
}

.submenu {
  display: none;
  position: absolute;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.submenu li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.submenu a {
  display: block;
  color: #333333;
  text-decoration: none;
}

.submenu a:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
}

.logoNav {
  position: absolute;
  top: -15px;
  left: 42%;
}

.logoNav > img {
  width: 200px;
}

@media screen and (max-width: 1200px) {
  .navbar-items {
    padding-right: 15%;

  }
}

@media screen and (max-width: 1000px) {
  .leftNavEn {
    margin-right: 0%;
  }
  .homeNav {
    display: block;
  }
  /*
  .navbar-items,
  .logoNav {
    display: none;
  }
*/
.navbar-items {
    display: none;
  }

  .logoNav>img{
    width: 70px;
    margin-top: 12px;
  }

  .leftNav {
    margin-right: 0%;
  }

  .navbar-items.show-menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    top: 70px;
    left: 0;
    background-color: #2B2B2B;
    width: 100%;
    padding: 10px;
    box-shadow: 0 5px 5px rgba(78, 73, 73, 0.2);
  }

  .navbar-items.show-menu li {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .navbar-toggle {
    display: block;
    cursor: pointer;
  }

  .navbar-toggle span {
    display: block;
    width: 25px;
    height: 3px;
    margin-bottom: 5px;
    background-color: white;
    border-radius: 3px;
  }
}
</style>
